import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/film" },
  { label: "电视剧", to: "/category/tv" },
  { label: "动漫", to: "/category/dongman" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
    setKeyword("");
    setMenuOpen(false);
  };

  const isActive = (to: string) => (to === "/" ? location.pathname === "/" : location.pathname.startsWith(to));

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/60 bg-background-50/90 backdrop-blur-md">
      <div className="flex h-16 items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2 text-foreground-950" aria-label="屁屁影院首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-xl" />
          </span>
          <span className="font-heading text-xl font-bold tracking-wide">屁屁影院</span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive(item.to)
                  ? "bg-primary-100 text-primary-300"
                  : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="ml-auto hidden items-center md:flex">
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索电影、电视剧"
              aria-label="搜索影视"
              className="w-56 rounded-full border border-background-200 bg-background-100 py-2 pl-9 pr-4 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-1 focus:ring-primary-400"
            />
          </div>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开菜单"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-950 hover:bg-background-100 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/60 bg-background-50 px-4 py-4 md:hidden">
          <form onSubmit={submitSearch} className="mb-4 flex items-center gap-2">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索电影、电视剧"
                aria-label="搜索影视"
                className="w-full rounded-full border border-background-200 bg-background-100 py-2 pl-9 pr-4 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-accent-600"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-md px-3 py-2.5 text-sm font-medium ${
                  isActive(item.to) ? "bg-primary-100 text-primary-300" : "text-foreground-600 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}